import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../app/stores/rootStore";
import React, { useContext, useEffect, useRef } from "react";
// reactstrap components
import { Row, Col, Button } from "reactstrap";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import ArchiveTreeComponent from "../components/archive/ArchiveTreeComponent";
import ArchiveTreeIcon from "../components/archive/ArchiveTreeIcon";
import { contentTipology } from "../app/models/node";
import { EventDataNode } from "rc-tree/lib/interface";

const STYLE = `
.rc-tree-child-tree {
  display: block;
}
.node-motion {
  transition: all .3s;
  overflow-y: hidden;
}
`;

interface DetailParams {
    archiveId: string;
    archiveName: string;
  }

const ArchiveContentPage: React.FC<RouteComponentProps<DetailParams>> = ({ history,match }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { setAutoOpeningFolder } =
    rootStore.archiveStore;
  const ref = useRef<null | HTMLDivElement>(null);
  const link = useRef<null | HTMLAnchorElement>(null);
  const { loadNodes, resetNodeTree, currentTree} =
    rootStore.archiveStore;
  const [t] = useTranslation(["features"], translationHookOptions);
  const { isMobileMediaQuery } = rootStore.responsiveStore;


 

  const treeIconComponent = (nodeKey: string, hasDocument?: boolean, type?: contentTipology, hasChildren? : boolean, expandedByDefault?: boolean) => {
    return (
      <ArchiveTreeIcon nodeKey ={nodeKey} hasDocument ={hasDocument} type={type} hasChildren={hasChildren} expandedByDefault= {expandedByDefault}></ArchiveTreeIcon>
    )
  }

  // const handleSelect= (node: EventDataNode) => {
  //   let tipology = node.className?.slice()
  //   if(node.tipology !== undefined && notViewableTipology.some(x => x === node.tipology)) return;

  //   history.push(`../browse/${match.params.archiveId}/content/${node.contentId}`)
  //   // /:tenant/browse/archive/:archiveId/content/:contentId
  // }

  useEffect(() => {
    let intArchiveId = parseInt(match.params.archiveId);
    loadNodes(intArchiveId)
      .then((res) => {
        const scrollableElement = document.querySelector(".odgPage");
        if (scrollableElement) disableBodyScroll(scrollableElement);
      })
      .catch();
    return () => {
      resetNodeTree();
      const scrollableElement = document.querySelector(".odgPage");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, [loadNodes, match.params.archiveId, resetNodeTree]);

  
  const handleExpandAll = () => {
    setAutoOpeningFolder(true);
  }
  const handleCollapseAll = () => {
    setAutoOpeningFolder(false);
  }

  return (
    <>
      <div className="odgPage">
        <style dangerouslySetInnerHTML={{ __html: STYLE }} />
        <div
          className={classnames(
            "parent",
            `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
          )}
        >
          <div
            className={classnames(
              isMobileMediaQuery
                ? "odgTitoloRepositoryMobile"
                : "odgTitoloRepository",
              "left margin-right-auto",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
            {t("archiveContents_page_title_bar" ,`${currentTree?.title}`)}
          </div>
          <div
            className={classnames(
              isMobileMediaQuery
                ? "odgTitoloRepositoryMobile"
                : "odgTitoloRepository",
              "right",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
            
            {/* <button
              className={classnames(
                isMobileMediaQuery
                  ? "buttonAddPresentationMobile"
                  : "buttonAddPresentation",
                "right",
                "buttonSimple"
              )}
              onClick={() => {
                openShowPresentationModal();
              }}
              style={{ textDecoration: "none", float: "right" }}
              color="link"
            >
              <span className="btn-inner--icon">
                <i className="fas fa-plus text-white bg-dark" />
              </span>
              <span className="btn-inner--text  text-white bg-dark">
                {" "}
                {t("mydocs_page_add_file")}
              </span>
            </button> */}
          </div>
        </div>
        <Row style={{ margin: "1em 0", justifyContent: "flex-end"}}>
            <div>
              <Button
              color={theme!.buttonColor}
              className = {"float-right mr-2 ml-2 no-wrap genericButton " + theme!.buttonColor + " " + theme!.buttonTextColor + " " + theme!.buttonBorderColor}
              onClick={handleExpandAll}
              >
              <span className="btn-inner--icon">
                  <i className="fal fa-folder-open" style={{}}/>
              <span className="btn-inner--text"> {t("btn_open_all")}</span>
              </span>
              </Button>
            </div>
            <div>
              <Button
              className = {"float-right mr-2 ml-2 no-wrap genericButton " + theme!.buttonColor + " " + theme!.buttonTextColor + " " + theme!.buttonBorderColor}
              color={theme!.buttonColor}
              onClick={handleCollapseAll}
              >
              <span className="btn-inner--icon">
                  <i className="fal fa-folder" style={{}}/>
              <span className="btn-inner--text"> {t("btn_close_all")}</span>
              </span>
              </Button>
            </div>
        </Row>
        <Row>
          <Col xs={12} className="odgContainer">
            {currentTree && currentTree.tree.length > 0 && (
              <ArchiveTreeComponent
              archiveId={match.params.archiveId}
                dataArray={currentTree.tree}
                // handleSelect= {handleSelect}
                treeIconComponent={treeIconComponent}
              ></ArchiveTreeComponent>
            )}
          </Col>
        </Row>
      </div>
      {/* <GenericModal
        size="md"
        title={t("mydocs_page_add_file")}
        isOpen={showPresentationModal}
        toggle={() => closeShowPresentationModal()}
        content={<PresentationForm></PresentationForm>}
      ></GenericModal> */}
    </>
  );
};

export default observer(ArchiveContentPage);
